<template>
  <div class="products">
    <banner banner="product" />
    <div class="products-box flex-row">
      <div class="products-menu flex-col" v-if="isPc">
        <div v-for="(item, index) in typeListRes" :key="item.prodTypeId">
          <div
            :class="[
              'products-menu-item',
              'items-center',
              'little_hand',
              { active: index == activeType },
            ]"
            @click="change(index)"
          >
            <div class="line"></div>
            <h3>{{ item.prodTypeName }}</h3>
            <div
              class="more items-center little_hand"
              v-if="index == activeType"
            >
              <svg-icon icon-class="arrow"></svg-icon>
              <svg-icon icon-class="arrow"></svg-icon>
            </div>
          </div>
        </div>
      </div>
      <div
        class="products-mobile-menu items-center"
        v-if="!isPc"
        @click="drawer = true"
      >
        <h3>切换产品系列</h3>
        <span class="items-center">
          <svg-icon className="icon1" icon-class="arrow"></svg-icon>
          <svg-icon className="icon1 icon2" icon-class="arrow"></svg-icon>
        </span>
      </div>
      <el-drawer
        title=""
        append-to-body
        :visible.sync="drawer"
        :direction="direction"
        class="products-menu"
      >
        <div v-for="(item, index) in typeListRes" :key="item.prodTypeId">
          <div
            :class="[
              'products-menu-item',
              'items-center',
              'little_hand',
              { active: index == activeType },
            ]"
            @click="change(index)"
          >
            <div class="line"></div>
            <h3>{{ item.prodTypeName }}</h3>
            <div
              class="more items-center little_hand"
              v-if="index == activeType"
            >
              <svg-icon icon-class="arrow"></svg-icon>
              <svg-icon icon-class="arrow"></svg-icon>
            </div>
          </div>
        </div>
      </el-drawer>
      <div class="products-con">
        <div class="title items-end">
          <svg-icon className="icon1" icon-class="square"></svg-icon>
          <svg-icon className="icon2" icon-class="square"></svg-icon>
          <h2 v-if="typeListRes[activeType]">
            {{ typeListRes[activeType].prodTypeName }}
            <div class="square"></div>
          </h2>
        </div>
        <div class="desc" v-if="typeListRes[activeType]">
          {{ typeListRes[activeType].prodTypeDescrip }}
          <!-- 水力控制阀是一个总称，由一只主阀及其外装之针阀、向导阀等组合而成的一类自动控制阀。水力控制阀的工作状态一般呈常用状态、常开状态、浮动状态，主要依靠主阀与针阀或导阀之间调节来进行控制水流状态。 -->
        </div>
        <h3 v-if="prodListRes.length > 0">产品列表</h3>
        <el-row :gutter="isPc ? 16 : 12">
          <el-col
            :span="isPc ? 6 : 12"
            v-for="item in prodListRes"
            :key="item.prodId"
          >
            <div
              class="products-info little_hand"
              @click="toProductDetails(item.prodId)"
            >
              <div class="img-box">
                <img :src="item.prodImage" />
                <div class="img-border"></div>
              </div>
              <h4>{{ item.prodName }}</h4>
              <!-- <span>100C SERIES</span> -->
            </div>
          </el-col>
        </el-row>
        <div class="justify-center" style="margin-top: 40px">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="changeSize"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- <router-view></router-view> -->
  </div>
</template>

<script>
import banner from "../common/banner.vue";

import { mapState } from "vuex";
import { getTypeList, getProdList } from "@/assets/api/products.js";

export default {
  name: "products",
  components: {
    banner,
  },
  data() {
    return {
      activeType: "0",
      typeListRes: [],
      prodListRes: [],
      drawer: false,
      direction: "rtl",
      total: 0,
      pageNum: 1,
      pageSize: 8,
    };
  },
  computed: {
    ...mapState(["isPc"]),
  },
  created() {
    getTypeList({
      orderByColumn: "orderNum",
      isAsc: "desc",
      pageNum: 1,
      pageSize: 100,
    }).then((res) => {
      // console.log(res.data);
      this.typeListRes = res.data.data.rows;
      // this.activeType = this.typeListRes[0].prodTypeId;
      this.init();
    });
  },
  methods: {
    change(index) {
      this.activeType = index;
      this.pageNum = 1;
      this.pageSize = 8;
      this.init();
      this.drawer = false;
    },
    init() {
      getProdList({
        orderByColumn: "orderNum",
        isAsc: "desc",
        prodTypeId: this.typeListRes[this.activeType].prodTypeId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        console.log(res.data);
        this.total = res.data.data.total;

        this.prodListRes = res.data.data.rows.map((item) => {
          item.prodImage = item.prodImage ? item.prodImage.split(",") : [];
          item.prodImage = !/^http/.test(item.prodImage[0])
            ? this.$imgUrl + item.prodImage[0]
            : item.prodImage[0];
          return item;
        });
      });
    },
    changeSize(e) {
      console.log(e);
      this.pageNum = e;
      this.init();
    },
    toProductDetails(prodId) {
      this.$router.push({
        path: `/products-details/${prodId}`,
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.products-box {
  width: 1100px;
  margin: auto;
  position: relative;
  z-index: 10;
  padding: 60px 0 80px;
  .products-menu {
    width: 200px;
    margin-right: 80px;
    .products-menu-item {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #636366;
      letter-spacing: 0;
      font-weight: 400;
      padding: 8px 0;
      .line {
        width: 24px;
        height: 1px;
        background: #636366;
        margin-right: 8px;
      }
    }
    .active {
      h3 {
        font-weight: 700;
      }
      color: #005bac;
      .line {
        width: 64px;
        height: 2px;
        background: #005bac;
      }
      .more {
        .svg-icon {
          width: 16px;
          height: 16px;
        }
        .svg-icon:last-child {
          margin-left: -8px;
        }
        margin-left: 8px;
      }
    }
  }
  .products-con {
    flex: 1;
    .title {
      .icon1 {
        width: 20px;
        height: 36px;
        color: #005bac;
      }
      .icon2 {
        width: 20px;
        height: 36px;
        color: rgba($color: #005bac, $alpha: 0.4);
        margin-left: -4px;
      }
      h2 {
        font-size: 36px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #005bac;
        line-height: 47px;
        position: relative;
        padding: 8px 20px;
        box-sizing: border-box;
        .square {
          width: 100%;
          height: 36px;
          transform: skew(-13deg);
          background-color: rgba($color: #005bac, $alpha: 0.16);
          position: absolute;
          left: 0;
          bottom: 0;
        }
        .svg-icon {
          width: 100%;
          height: 36px;
          color: rgba($color: #005bac, $alpha: 0.16);
          object-fit: cover;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
    .desc {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #2c2c2e;
      letter-spacing: 0;
      line-height: 28px;
      font-weight: 400;
      margin-top: 16px;
      margin-bottom: 40px;
    }
    h3 {
      font-family: MicrosoftYaHei-Bold;
      font-size: 18px;
      color: #2c2c2e;
      letter-spacing: 0;
      font-weight: 700;
      margin-bottom: 16px;
    }
    .products-info {
      margin-bottom: 16px;
      .img-box {
        position: relative;
        width: 100%;
        height: 240px;
        .img-border {
          width: 100%;
          height: 100%;
          border: 4px solid transparent;
          position: absolute;
          top: 0;
          left: 0;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          background: #f2f2f7;
          border-bottom: 2px solid #005bac;
        }
      }

      h4 {
        font-family: MicrosoftYaHei-Bold;
        font-size: 16px;
        color: #2c2c2e;
        letter-spacing: 0;
        font-weight: 700;
        margin-top: 8px;
        margin-bottom: 4px;
        height: 44px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        word-break: break-all;
      }
      span {
        font-family: Arial-ItalicMT;
        font-size: 12px;
        color: #aeaeb2;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .products-info:hover {
      .img-box {
        .img-border {
          border: 4px solid rgba(0, 91, 172, 1);
        }
      }

      h4 {
        color: #005bac;
      }
      span {
        color: #005bac;
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .products-box {
    width: 100%;
    padding: 0 20px;
    margin-top: 40px;
    margin-bottom: 48px;
    flex-direction: column;
    .products-mobile-menu {
      margin-bottom: 8px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #005bac;
      line-height: 28px;
      h3 {
        margin-right: 4px;
      }
      .icon1 {
        width: 16px;
        height: 16px;
      }
      .icon2 {
        margin-left: -8px;
      }
    }
    .products-con {
      flex: 1;
      .title {
        .icon1 {
          width: 16px;
          height: 28px;
        }
        .icon2 {
          width: 16px;
          height: 28px;
          margin-left: -2px;
        }
        h2 {
          font-size: 24px;
          line-height: 31px;
          padding: 6px 14px;
          .square {
            width: 100%;
            height: 28px;
            transform: skew(-13deg);
          }
        }
        .more {
          font-size: 14px;
          .svg-icon {
            width: 24px;
            height: 12px;
            margin-left: 4px;
          }
        }
      }
      .desc {
        font-size: 14px;
        line-height: 24px;
      }
      h3 {
        font-size: 16px;
      }
      .products-info {
        margin-bottom: 12px;
        img {
          width: 100%;
          height: 203px;
          object-fit: cover;
        }
        h4 {
          font-size: 14px;
        }
      }
    }
  }
  .products-menu {
    .products-menu-item {
      font-family: MicrosoftYaHei;
      font-size: 16px;
      color: #636366;
      letter-spacing: 0;
      font-weight: 400;
      padding: 12px 24px;
      .line {
        width: 24px;
        height: 1px;
        background: #636366;
        margin-right: 8px;
      }
    }
    .active {
      h3 {
        font-weight: 700;
        white-space: nowrap;
      }
      color: #005bac;
      .line {
        width: 64px;
        height: 2px;
        background: #005bac;
      }
      .more {
        .svg-icon {
          width: 16px;
          height: 16px;
        }
        .svg-icon:last-child {
          margin-left: -8px;
        }
      }
    }
  }
}
</style>

<style>
.products-menu .el-drawer {
  width: 62% !important;
}
.el-pager li {
  font-size: 16px;
  padding: 0 8px;
  height: auto;
}
.el-pager li:hover {
  color: #005bac;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #005bac;
}
</style>


// WEBPACK FOOTER //
// src/views/products-list/index.vue